import { Link } from 'react-router-dom';
import { Button, Table } from 'react-bootstrap';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import EmptyState from '../../../components/feedback/EmptyState';
import type { BundleListRow } from '../types';

interface BundleListTableProps {
  bundles: BundleListRow[];
  onCreate: () => void;
  onEdit: (bundle: BundleListRow) => void;
  onDelete: (bundle: BundleListRow) => void;
}

const BundleListTable = ({ bundles, onCreate, onEdit, onDelete }: BundleListTableProps) => {
  const { t } = useTranslation();

  if (bundles.length === 0) {
    return (
      <EmptyState
        className="py-5"
        icon={<i className="ti ti-package app-empty-state__icon-glyph" aria-hidden="true" />}
        title={t('warehouses.bundles.noBundles')}
        message={t('warehouses.bundles.emptyMessage', 'No bundle templates exist yet. Add one to start grouping stock items into reusable sets.')}
        action={<Button onClick={onCreate}>{t('warehouses.bundles.newBundle')}</Button>}
      />
    );
  }

  return (
    <Table hover responsive className="table-vcenter card-table app-table mb-0">
      <thead>
        <tr>
          <th>{t('warehouses.bundles.name')}</th>
          <th>{t('warehouses.bundles.qrCode')}</th>
          <th>{t('warehouses.bundles.entryCount')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {bundles.map((bundle) => (
          <tr key={bundle.id}>
            <td>
              <Link to={`/warehouses/bundles/${bundle.id}`} className="fw-semibold">
                {bundle.name}
              </Link>
              {bundle.description && <div className="text-muted small">{bundle.description}</div>}
            </td>
            <td><code className="small">{bundle.qr_code}</code></td>
            <td>{bundle.entry_count}</td>
            <td className="text-end">
              <Button variant="ghost-secondary" size="sm" onClick={() => onEdit(bundle)} className="me-1">
                <IconEdit size={16} />
              </Button>
              <Button variant="ghost-danger" size="sm" onClick={() => onDelete(bundle)}>
                <IconTrash size={16} />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default BundleListTable;
